"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _MuiIconButtonRedirect = _interopRequireDefault(require("../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _MuiIconButton = _interopRequireDefault(require("../MuiIconButton/MuiIconButton"));

var _GoogleConversions = _interopRequireDefault(require("../GoogleConversions/GoogleConversions"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var MuiBottomNavigation = function MuiBottomNavigation(_ref) {
  var rootClass = _ref.rootClass,
      showLabels = _ref.showLabels,
      navActions = _ref.navActions,
      width = _ref.width,
      position = _ref.position,
      bottom = _ref.bottom;
  var components = {
    MuiIconButton: _MuiIconButton.default,
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default,
    GoogleConversions: _GoogleConversions.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    width: parseInt(width, 10),
    position: position,
    bottom: parseInt(bottom, 10)
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    value: value,
    onChange: function onChange(e, newValue) {
      setValue(newValue);
    },
    showLabels: showLabels,
    className: styles.root
  }, navActions.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, (0, _extends2.default)({}, item, {
      key: item.value,
      icon: /*#__PURE__*/(0, _react.createElement)(components[item.icon[0].component], Object.assign(item.icon[0]))
    }));
  }));
};

var _default = MuiBottomNavigation;
exports.default = _default;
MuiBottomNavigation.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: boolean
   * If true, all BottomNavigationActions will show their labels.
   * By default, only the selected BottomNavigationAction will show its label.
   */
  showLabels: _propTypes.default.bool,

  /**
   * mui prop: number
   * Width of the bottom navigation bar.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * 'absolute', 'fixed'
   * Position of the Mui Bottom Navigation.
   */
  position: function position(props, propName, componentName) {
    var validProp = ['absolute', 'fixed'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: number
   * Number of pixels from the bottom the nav bar is set to.
   */
  bottom: _propTypes.default.string,

  /**
   * components:
   * MuiBottomNavigationAction
   */
  navActions: function navActions(props, propName, componentName) {
    var components = ['MuiBottomNavigationAction'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiBottomNavigation.defaultProps = {
  rootClass: [],
  showLabels: false,
  width: '500',
  position: 'fixed',
  bottom: '30',
  navActions: []
};